"use client";
import * as React from "react";
import { useRef, useEffect } from "react";
import Button from "../Button/index";
import { ConfirmationPromptProps } from "../types";
import defaultClasses from "./index.module.css";

function ConfirmationPrompt(props: ConfirmationPromptProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    cancelRef.current?.focus();
  }, []);

  return (
    <div className={defaultClasses.confirmationDiv}>
      <h6>{props.promptMessage}</h6>
      <div className={defaultClasses.buttonsDiv}>
        <Button
          type="button"
          name={props.buttonNames?.ctoa || "Confirm"}
          variant={props.ctoaVariant}
          handleClick={props.confirmationCallback}
          classNames={props.classNames?.button?.ctoa}
        />
        <Button
          type="button"
          variant="outline"
          name={props.buttonNames?.cancel || "Cancel"}
          handleClick={props.cancelCallback}
          classNames={props.classNames?.button?.cancel}
          buttonRef={cancelRef}
        />
      </div>
    </div>
  );
}

export default ConfirmationPrompt;
